interface IProps {
    width?: number;
    height?: number;
}

export const PlayNextIcon = (props: IProps) => {
    const {width, height} = props;
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 16}
        height={height || 18}
        viewBox="0 0 16 18"
        fill="none"
    >
        <path
            d="M13 17.3528H15.5V0.686157H13V7.90281L0.5 0.686157V17.3528L13 10.1362V17.3528Z"
            fill="#FCFCFC"
        />
    </svg>);
}